"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchByPlaceName = searchByPlaceName;
var places_json_1 = __importDefault(require("../static/places.json"));
var radixTrie_1 = __importDefault(require("./radixTrie"));
var constants_1 = require("./constants");
function parsePlacesJSON(placesJSON) {
    var ret = [];
    for (var i = 0; i < placesJSON.length; i += 3) {
        var name_1 = placesJSON[i];
        if (typeof name_1 !== "string") {
            throw new Error("Invalid name: ".concat(name_1));
        }
        var lat = placesJSON[i + 1];
        if (typeof lat !== "number") {
            throw new Error("Invalid lat: ".concat(lat));
        }
        var lng = placesJSON[i + 2];
        if (typeof lng !== "number") {
            throw new Error("Invalid lng: ".concat(lng));
        }
        var place = [name_1, [lat, lng]];
        ret.push(place);
    }
    return ret;
}
var places = parsePlacesJSON(places_json_1.default);
var DEFAULT_MAX_NUM_RESULTS = 10;
function placeNameToGeolevel(placeName) {
    return /(County|Municipio), [A-Z]{2}$/.test(placeName)
        ? "county"
        : /, [A-Z]{2}$/.test(placeName)
            ? "city"
            : "state";
}
function placeNameIsInArea(placeName, alphaFIPSCode) {
    return (
    // eg. "Pennsylvania" matches PA
    constants_1.alphaFIPSCodeToAreaName[alphaFIPSCode] === placeName ||
        // eg. "Philadelphia, PA" matches PA
        placeName.endsWith(", " + alphaFIPSCode));
}
function sortByPopulationRank(a, b) {
    return a.populationRank - b.populationRank;
}
var placesTrie = new radixTrie_1.default();
places.forEach(function (_a, index) {
    var placeName = _a[0], _coords = _a[1];
    placesTrie.insert(placeName, index);
});
var defaultOptions = {
    maxNumResults: DEFAULT_MAX_NUM_RESULTS,
    sortFunc: sortByPopulationRank,
    excludedAreas: [],
};
function searchByPlaceName(placeName, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var opts = __assign(__assign({}, defaultOptions), options);
    return ((_a = placesTrie.search(placeName)) !== null && _a !== void 0 ? _a : [])
        .map(function (id) {
        var _a = places[id], name = _a[0], coordinates = _a[1];
        var geolevel = placeNameToGeolevel(name);
        // NOTE: ids are pre-sorted in the data by population!
        return { populationRank: id, name: name, coordinates: coordinates, geolevel: geolevel };
    })
        .filter(function (_a) {
        var name = _a.name;
        return opts.excludedAreas.every(function (excludedAreaAlphaFIPSCode) {
            return !placeNameIsInArea(name, excludedAreaAlphaFIPSCode);
        });
    })
        .sort(opts.sortFunc)
        .filter(function (_, index) { return index < opts.maxNumResults; });
}
